export const actionOptions = {
  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
  "all": [
    {
      icon: 'toggle-on',
      title: 'Activate Selected Products',
      cls: "bulk-activate-product",
      disabled: false
    },
    {
      icon: 'toggle-off',
      title: 'Deactivate Selected Products',
      cls: "bulk-deactivate-product",
      disabled: false
    }
  ],
  "actions": [
    {
      title: "Edit",
      cls: "edit-product",
      icon: "pencil",
      disabled:false
    },
    {
      title: "Activate/Deactivate",
      cls: "",
      icon: "",
      disabled:false
    },
    {
      title: "Duplicate",
      cls: "duplicate-product",
      icon: "clone",
      disabled:false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/pages/products/filter/actionOptions.js